export class VideoLink {
  constructor(data) {
    var self = this;
    self.type = "VideoLink";

    if (data == undefined) {
      data = {};
    }

    self.link_type = ko.observable(data.link_type);

    self.link_uuid = ko.observable(data.video_link_uuid);

    self.link_url = ko.observable(data.link_url);
    self.player_link = ko.observable(data.player_link);
    self.preview = ko.observable(data.preview);
    self.video_link_uuid = ko.observable(data.video_link_uuid);
  }
}

export class StreamingLink {
  constructor(data) {
    var self = this;
    self.type = "StreamingLink";

    if (data == undefined) {
      data = {};
    }

    self.link_type = ko.observable(data.link_type);
    self.link_url = ko.observable(data.link_url);
    self.link_uuid = ko.observable(data.link_uuid);
    self.media_type = ko.observable(data.media_type);
    self.username = ko.observable(data.username);
    self.streamtype = ko.observable(data.streamtype);
    self.streamname = ko.observable(data.streamname);
    self.streamid = ko.observable(data.streamid);

    self.streamurl = ko.pureComputed(function () {
      switch (self.link_type()) {
        case "spotify":
          return (
            "https://open.spotify.com/embed/" +
            self.streamtype() +
            "/" +
            self.streamid()
          );
        case "soundcloud":
          streamtype = self.streamtype() != "track" ? "/sets" : "";
          return (
            "https://w.soundcloud.com/player/?url=https://soundcloud.com/" +
            self.username() +
            streamtype +
            "/" +
            self.streamname() +
            "&color=%230F9388&show_playcount=false&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false"
          );
        case "bandcamp":
          return (
            "https://bandcamp.com/EmbeddedPlayer/" +
            self.streamtype() +
            "=" +
            self.streamid() +
            "/size=large/bgcol=ffffff/linkcol=0F9388/tracklist=false/artwork=small/transparent=true/"
          );
        default:
          return null;
      }
    });
  }
}

export class WebLink {
  constructor(data) {
    var self = this;
    self.type = "WebLink";

    if (data == undefined) {
      data = {};
    }

    self.link_type = ko.observable(data.link_type);
    self.link_url = ko.observable(data.link_url);
    self.link_uuid = ko.observable(data.link_uuid);

    self.image_path = ko.computed(function () {
      switch (self.link_type()) {
        case "facebook":
          return "/images/network/facebook_grey.png";
          break;
        case "website":
          return "/images/network/url.png";
          break;
        case "youtube":
          return "/images/network/youtube_grey.png";
          break;
        case "twitter":
          return "/images/network/twitter_grey.png";
          break;
        case "instagram":
          return "/images/network/instagram_grey.png";
          break;
        default:
          return "";
      }
    });
    self.mdi_icon_class = ko.computed(() => {
      switch (self.link_type()) {
        case "facebook":
          return "mdi-facebook";
          break;
        case "website":
          return "mdi-web";
          break;
        case "youtube":
          return "mdi-youtube";
          break;
        case "twitter":
          return "mdi-twitter";
          break;
        case "instagram":
          return "mdi-instagram";
          break;
        default:
          return "";
      }
    });
  }
}
